const setIds = (state, ids) => {
  state.ids = ids;
};

const setMeta = (state, meta) => {
  state.meta = meta;
};

const setLinks = (state, links) => {
  state.links = links;
};

export default {
  setIds,
  setMeta,
  setLinks,
};
